import iconSrc from '@/assets/images/edit/config/ico-lef-mess@2x.png'
export default {
  // 对应数据库内类型
  orderById: 170,
  elementType: 'TimeBox',
  elementDesc: '时间题',
  type: 'timebox',
  category: 'tiankongti',
  // 是否可配置
  config: true,
  // 控件左侧label内容
  title: '时间题',
  placeholder: '时间题',
  isRequired: '1',
  toolbar: {
    edit: true,
    delete: true,
    copy: true,
    config: false
  },
  // 最大长度
  maxLength: 120,
  value: null,
  width: 300,
  ruleError: '该字段不能为空',
  timeTypeHourMinute: '时/分',
  timeTypeYearMonth: '年/月',
  timeTypeYearMonthDay: '年/月/日',
  timeTypeYearMonthDayHourMinute: '年/月/日/时/分',
  datetimeRange: '时间范围',
  saveUrl: '/design/qu-number/ajaxSave',
  iconStyle: {
    background: 'url(' + iconSrc + ')',
    backgroundSize: '100% 100%'
  },
  saveCb () {
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      answserScore: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/TimeBox/config.js